var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"fa"},[_c('img',{attrs:{"src":require("../assets/pic/success.png"),"alt":""}}),_c('span',{attrs:{"slot":"reference"},slot:"reference"},[_vm._v("成功")]),_c('p',[_vm._v(_vm._s(_vm.message))])])])}
var staticRenderFns = []

export { render, staticRenderFns }